import {IFetchResponse} from '@http/http.model';

export class SessionException extends Error {
    static type = 'SESSION_EXCEPTION';
    static message = 'Session failure';
}

export class MaintenanceException extends Error {
    static type = 'MAINTENANCE_EXCEPTION';
    static message = 'Maintenance in progress';
}

export class CancelException extends Error {
    static type = 'CANCEL_EXCEPTION';
    static message = 'Request was cancelled';
}

export class FetchException extends Error {
    constructor(message: string, response?: IFetchResponse) {
        super(message);
        this.response = response;
    }

    response?: IFetchResponse;
}

export class FetchNetworkException extends FetchException {
    static type = 'NETWORK_EXCEPTION';
    constructor(message: string, response?: IFetchResponse) {
        super(message, response);
    }
}

export class PaymentException extends Error {
    static type = 'PAYMENT_EXCEPTION';
    static message = 'Payment failure';
}

export class WebflowConfigException extends Error {
    static type = 'WEBFLOW_CONFIG_EXCEPTION';
    constructor(missingEnvKeys: string[]) {
        super(`Missing Webflow config: ${missingEnvKeys.join(', ')}`);
    }
}

export const ValidationException = class {
    constructor(arg: unknown) {
        Object.assign(this, arg);
    }
    static type = 'VALIDATION_EXCEPTION';
} as ValidationExceptionCtor;

export interface IFieldError {
    message?: string;
}

export type ValidationException<T = Record<string, IFieldError>> = T & {
    type: string;
};

type ValidationExceptionCtor = {
    new <T extends object>(arg: T): ValidationException<T>;
};
